<template>
  <section class="myIndex">
	
	<!--默认服务展示-->
	<div class="topWrap" v-if="serviceList.length === 0">
	  <div class="topItem">
		<div class="top">
		  <div>即刻体验 换背服务</div>
		</div>
		<div class="bot">
		  <div>
			<h2 class="f32 bold">换背服务中</h2>
			<ul class="f22 grey9">
			  <li>服务期内购包退货，陈真承诺全额退款</li>
			  <li>3个月内可享随意换背5只包</li>
			</ul>
		  </div>
		  <div class="t_center">
			<img class="default" src="/images/my/no_pro.png" alt="">
		  </div>
		</div>
	  </div>
	</div>
	
	<ul class="topWrap" v-else>
	  <li v-for="(item,index) in serviceList" :key="index" class="">
		<div class="topItem" v-if="index===0">
		  <div class="top">
			<div>换背服务中</div>
			<div @click="toRenewal(item)">{{serviceDetail.expireTimeString}}到期 <span>续费</span></div>
		  </div>
		  <div class="bot">
			<div>
			  <h2 class="f32 bold">{{item.serviceName}} <span class="f22 grey6">(生效中)</span></h2>
			  <ul class="f22 grey9" id="sp_ul">
				<li>还可以再换背体验{{item.changeNumber}}次哦</li>
				<li>过去的{{item.dayNumber}}天已拥有过{{item.alreadyChangeNumber}}只奢品包</li>
				<!--<li>{{item.startTimeString +'至'+ item.expireTimeString}}</li>-->
			  </ul>
			  <p class="time_limit">{{item.startTimeString +'至'+ item.expireTimeString}}</p>
			  <div class="button f22 t_center" @click="$router.push({name:'proList',query:{'lable':1}})">换背，现在去</div>
			</div>
			<div class="t_center">
			  <img v-if="currentBag" :src="currentBag.productPic  | formatImgUrl(450,450,true)" align="middle">
			  <img v-else class="default" src="/images/my/no_pro.png" alt="">
			  <p class="pro_name">{{currentBag ? currentBag.productName : ""}}</p>
			</div>
		  
		  </div>
		</div>
		
		<div class="botItem f22" v-else>
		  <p><span class="bold f26">{{item.serviceName}}</span>(未生效)</p> <time class="grey6">{{item.startTimeString +'至'+ item.expireTimeString}}</time>
		</div>
		
	  </li>
	</ul>

	<div class="list" v-for="(item,index) in  list" :key="index">
	  <h2 class="f32 bold">{{item.title}}</h2>
	  <ul class="f28 grey6">
		<li v-for="(li,liIndex) in item.data" :key="liIndex" @click="toViews(li)">
		  <!--<div class="r f26 grey9" v-if="li.num">{{li.num}}个待处理</div>-->
		  <div>
		  	 <img v-if="!li.isQuite" :src="li.imgUrl"/>
		  	 <span>{{li.name}}</span>
		  </div>
		  <time v-if="li.num && li.num>0">{{li.num}}</time>
		  
		</li>
	  </ul>
	</div>
  </section>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import myApi from '@api/my'
  import orderApi from '@api/order'
  import publicObj from '@utils/public'

  export default {
    name: "index",
    data() {
      return {
        serviceDetail: {},
        currentBag:null,
        swiperOption: {
          slidesPerView: 'auto',
          spaceBetween: 10,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
        },
        
        list:[
            {
            	  title:'我的个人中心',
            	  data:[
            	      {name:'购买订单',num:0, pathName:'purchaseOrder',imgUrl:'/svg/ic_wallet.svg'},
			      {name:'退回订单',num:0, pathName:'returnOrder',imgUrl:'/svg/ic_shipping.svg'},
			      {name:'优惠券', pathName:'coupon',imgUrl:'/svg/ic_YHJ.svg'},
			      {name:'地址管理', pathName:'addressList',imgUrl:'/svg/ic_location.svg'},
            	  ]
            },
            {
              title:'寻求帮助',
            	  data:[
            	      {name:'常见问题',pathName:'help',imgUrl:'/svg/ic_order.svg'},
			      {name:'客服与帮助',imgUrl:'/svg/ic_profile.svg'},
			      {name:'退出登录',isQuite:true},
            	  ]
            }
		  ],
      }
    },
    watch: {},
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo
      }),
      serviceList(){
        return this.serviceDetail.userServiceDTOList || []
	  }
    },
    created() {
      this.getUserServiceList();
      this.getCurrentBags()
      this.getOrderCount();
      
      if (publicObj.isWeiXin()) {
        this.list['寻求帮助'].length = 2
      }
    },
    mounted() {
    },
    methods: {
      ...mapMutations({
        clearUserInfo: 'user/clearUserInfo'
      }),
      //获取当前正在背的包
      getCurrentBags() {
      	orderApi.getCurrentBag().then(res => {
      		if(res) {
      			this.currentBag = res
      		}
      	}).catch(() => {})
      },
      // 获取用户有效服务列表
      getUserServiceList() {
        myApi.getUserServiceList().then(res => {
          this.serviceDetail = res;
        })
      },
      //获取待处理订单数
      async getOrderCount() {
        const [myOrderCount, returnOrderCount] = await Promise.all([myApi.getMyOrderCount(), myApi.getReturnOrderCount()])
        this.list[0].data[0].num = myOrderCount;
        this.list[0].data[1].num = returnOrderCount;
      },
      toViews(li) {
        if (li.pathName) {
          this.$router.push({name: li.pathName})
        } else if (li.isQuite) {
          this.$dialog.confirm({
            title: '提示',
            message: '是否确认要退出'
          }).then(() => {
            localStorage.clear();
            this.clearUserInfo();
            this.$router.push({name: 'shoppingMall'})
          }).catch(() => {
          });
        } else {
          this.$showKeFuPopup()
        }
      },
      toRenewal(item) {
        this.$router.push({name: 'renewal', query: {id: item.id}})
      }
    }

  }
</script>

<style lang="scss" scoped>
  .myIndex {
	padding: 0 0 120px;
	.topWrap {
	  padding: 30px 40px 80px;
	  /*position: relative;*/
	  .topItem {
		width: 670px;
		/*height: 414px;*/
		border-radius: 20px;
		box-shadow: $base-shadow;
		box-sizing: border-box;
		overflow: hidden;
		/*position: absolute;*/
		/*left: 0;*/
		/*top:0;*/
		.top {
		  height: 66px;
		  line-height: 66px;
		  padding: 0 30px;
		  background: $primary-color;
		  color: $white-color;
		  display: flex;
		  justify-content: space-between;
		  
		  span {
			display: inline-block;
			width: 100px;
			height: 38px;
			margin-left: 16px;
			line-height: 38px;
			text-align: center;
			background: $white-color;
			color: $primary-color;
			border-radius: 22px;
		  }
		}
		
		.bot {
		  padding: 28px 48px 46px 48px;
		  display: flex;
		  #sp_ul{padding-bottom: 0;}
		  .pro_name{font-size: 22px;}
		  .time_limit{margin:19px 0 32px 0;
		     color: $base-grey;
		     font-size: 22px;
		  }
		  > div {
			&:first-child {
			  flex: 2;
			}
			
			&:last-child {
			  flex: 1;
			}
			
			h2 {
			  line-height: 60px;
			}
			
			ul {
			  padding: 20px 0 28px;
			  
			  li {
				margin-bottom: 12px;
				line-height: 32px;
				padding-left: 26px;
				position: relative;
				
				&:after {
				  content: '';
				  width: 12px;
				  height: 12px;
				  position: absolute;
				  left: 4px;
				  top: 10px;
				  border-radius: 50%;
				  background: $primary-color;
				  
				}
			  }
			  
			}
			
			.button {
			  width: 200px;
			  height: 62px;
			  line-height: 62px;
			  border-radius: 32px;
			  border: 1px $primary-color solid;
			}
			
			img {
			  width: 240px;
			  height: 240px;
			}
			
			.default {
			  width: 200px;
			  height: 200px;
			  padding: 20px;
			}
			
			h3 {
			  line-height: 22px;
			}
		  }
		}
	  }
	  
	  .botItem{
		height: 68px;
		line-height: 68px;
		padding:0 40px;
		background: #F8F8F8;
		box-shadow: $base-shadow;
		display: flex;
		justify-content: space-between;
	  }
	}
	
	/*.swiperWrap{*/
	/*padding: 10px 0 60px ;*/
	/*}*/
	/*.mySwiper{*/
	/*padding: 20px 0;*/
	/*}*/
	
	
	.list {
	  padding: 0 40px;
	  
	  h2 {
		/*padding: 80px 0 6px;*/
		line-height: 44px;
		margin-bottom: 6px;
	  }
	  
	  ul {
		margin-bottom: 80px;
	  }
	  
	  li{
	  	display: flex;
	  	justify-content: space-between;
	  	align-items: center;
		padding: 34px 0;
		border-bottom: $light-border;
		line-height: 40px;
		background: url("/images/base/arrow_right.png") no-repeat right center;
		background-size: 10px;
		div{
		  display: flex;
		  align-items: center;	
		  margin-right: 36px;
		  img{height: 34px;
		      width: 34px;
		      margin-right: 12px;
		      }
		}
		time{margin-right: 23px;
		     height: 40px;
		     width: 40px;
		     border-radius: 50%;
		     text-align: center;
		     line-height: 40px;
		     background: #f72461;
		     color: white;
		     font-size: 12px;
		}
	  }
	}
  }

</style>
